// Workspace switcher at the top of the rail: the workspace's logo (no name), opening the workspace menu —
// settings, invite people, switch or create a workspace.
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, Settings, UserPlus } from '@/components/ui/icons';
import { useDb } from '@/lib/store';
import { useWorkspaceId } from '@/lib/nav';
import { Popover } from '@/components/ui/Popover';
import { Menu, MenuItem, MenuLabel, MenuSeparator } from '@/components/ui/Menu';
import { WorkspaceLogo } from './WorkspaceLogo';
import { InviteModal } from './InviteModal';
import { useIsGuest } from '@/lib/roles';

export function WorkspaceSwitcher() {
  const ws = useWorkspaceId();
  const workspace = useDb((db) => db.workspaces[ws]);
  const workspaces = useDb((db) => db.workspaces);
  const navigate = useNavigate();
  const [invite, setInvite] = useState(false);
  const guest = useIsGuest();
  const name = workspace?.name ?? 'Workspace';

  return (
    <>
      <Popover
        placement="right-start"
        content={(close) => (
          <Menu style={{ width: 280 }}>
            <div className="ws-menu-head">
              <WorkspaceLogo workspaceId={ws} size={36} />
              <div className="grow">
                <div className="ws-menu-name truncate">{workspace?.name}</div>
                <div className="faint" style={{ fontSize: 'var(--fs-sm)' }}>
                  {workspace?.memberIds.length ?? 0} members
                </div>
              </div>
            </div>
            <MenuSeparator />
            <MenuItem icon={<Settings size={15} />} label="Settings" onClick={() => (close(), navigate(`/${ws}/settings`))} />
            {!guest && <MenuItem icon={<UserPlus size={15} />} label="Invite people" onClick={() => (close(), setInvite(true))} />}
            <MenuSeparator />
            <MenuLabel>Switch Workspaces</MenuLabel>
            {Object.values(workspaces).map((w) => (
              <MenuItem
                key={w.id}
                icon={<WorkspaceLogo workspaceId={w.id} size={18} />}
                label={w.name}
                right={w.id === ws ? <Check size={14} className="faint" /> : undefined}
                onClick={() => (close(), navigate(`/${w.id}/home`))}
              />
            ))}
          </Menu>
        )}
      >
        <button className="rail-ws" aria-label={`${name} — workspace menu`} title={name}>
          <WorkspaceLogo workspaceId={ws} size={36} />
        </button>
      </Popover>
      <InviteModal open={invite} onClose={() => setInvite(false)} />
    </>
  );
}
